import { useContext } from 'react';
import context from './remoteConfigContext';

export default function useRemoteConfig() {
  const value = useContext(context);
  if (value === undefined) {
    throw new Error(
      `${useRemoteConfig.name} must be used within a ${context.displayName || 'context'} Provider`,
    );
  }

  return value;
}
